import React from 'react';

//   window.addEventListener('scroll', function () {
//     console.log('scroll: ' + (window.innerHeight + window.scrollY));
//     console.log('height: ' + document.body.offsetHeight);
//     if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight)      {
//         console.log('here!');
//     }
// });

var style = {
  
 
 
  position: "relative",
  left: "0",
  bottom: "0",
  height: "205px",
  width: "100%",
}

var phantom = {
display: 'block',
padding: "0px",
height: '205px',
width: '100%',
}


const Footer =()=>{

    return(
      <div>
      <div style={phantom} />
      <div style={style}>
       <footer className="page-footer grey darken-4">
        <div className="container">
          <div className="row">
            <div className="col l6 s12">
              <h5 className="white-text">Footer Content</h5>
              <p className="grey-text text-lighten-4">You can use rows and columns here to organize your footer content.</p>
            </div>
           
          </div>
        </div>
        <div className="footer-copyright">
          <div className="container">
          © 2020 PlanMaker | desinged by Ashish Maurya
          <a className="grey-text text-lighten-4 right" href="#!">More Links</a>
          </div>
        </div>
        
       
      
      </footer>
      </div>
      </div>
    
        
    
     
    )
}

export default Footer;